module.exports = __webpack_public_path__ + "static/media/healthQuestionaryNetwell.1569ce90.svg";